import { render, staticRenderFns } from "./ConfirmVerificationEmailModal.vue?vue&type=template&id=5c1b4bcc&scoped=true&"
import script from "./ConfirmVerificationEmailModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmVerificationEmailModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmVerificationEmailModal.vue?vue&type=style&index=0&id=5c1b4bcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1b4bcc",
  null
  
)

export default component.exports